import PropTypes from "prop-types";

import ProductCard from "@/components/data-display/card/product";

function SimilarProducts({ products }) {
  const MAX_PRODUCT_AMOUNT = 4;

  if (products?.length > 0) {
    return (
      <div className="space-y-[2.75rem]">
        <h2 className="text-[1.5rem] font-semibold text-grayDisplay-900">
          Similar Products
        </h2>

        <div className="grid grid-cols-2 gap-[0.75rem] lg:grid-cols-3 lg:gap-[1.563rem] xl:grid-cols-4">
          {products.slice(0, MAX_PRODUCT_AMOUNT).map((product) => (
            <ProductCard key={product.slug} product={product} />
          ))}
        </div>
      </div>
    );
  }

  return null;
}

SimilarProducts.propTypes = {
  products: PropTypes.array,
};

export default SimilarProducts;
